import { WallboxHardwareDto } from '../../dto/wallbox-hardware.dto'
import { WallboxHardwareModel } from '../../models'

const fromHardwareDtoToModel = (dto: WallboxHardwareDto): WallboxHardwareModel[] => {
  return (dto.id || []).map((value: number, index: number) => ({
    id: Number(value),
    wallboxId: dto.serialno[index],
    storageSerialNumber: dto.storageSerialno[index],
    moduleName: dto.moduleName[index],
    type: dto.type[index],
    appSoftware: dto.appSoftware[index],
    bootloaderSoftware: dto.bootloaderSoftware[index],
    deviceId: Number(dto.deviceId[index]),
    deviceName: dto.deviceName[index],
    firmware: dto.firmware[index],
    flashVersion: dto.flashVersion[index],
    hwVersion: dto.hwVersion[index],
    softwareVersion: dto.softwareVersion[index],
    sunMode: Number(dto.sunMode[index]),
    rfidReaderEnabled: Number(dto.rfidReaderEnabled[index]),
    number: dto.number[index],
    chargeStopHistory: dto.chargeStopHistory[index],
    cs: dto.cs[index],
    csDayTimeSu: dto.csDayTimeSu[index],
    csDayTimeMo: dto.csDayTimeMo[index],
    csDayTimeTu: dto.csDayTimeTu[index],
    csDayTimeWe: dto.csDayTimeWe[index],
    csDayTimeTh: dto.csDayTimeTh[index],
    csDayTimeFr: dto.csDayTimeFr[index],
    csDayTimeSa: dto.csDayTimeSa[index],
    csMinEnergySu: dto.csMinEnergySu[index],
    csMinEnergyMo: dto.csMinEnergyMo[index],
    csMinEnergyTu: dto.csMinEnergyTu[index],
    csMinEnergyWe: dto.csMinEnergyWe[index],
    csMinEnergyTh: dto.csMinEnergyTh[index],
    csMinEnergyFr: dto.csMinEnergyFr[index],
    csMinEnergySa: dto.csMinEnergySa[index],
    dipSwitchConf: dto.dipSwitchConf[index],
    ip: dto.ip[index],
    mac: dto.mac[index],
    keyLockMode: dto.keyLockMode[index],
    maxCurrent: dto.maxCurrent[index],
    minCurrent: dto.minCurrent[index],
    numberPhases: dto.numberPhases[index],
    upperCurrentLimit: dto.upperCurrentLimit[index],
    wallboxType: Number(dto.wbType[index]),
    authValid: dto.authValid[index],
    outdated: dto.outdated[index],
    lastSend: dto.lastSend[index],
    setTime: dto.setTime[index],
    createdAt: dto.createdAt[index],
    updatedAt: dto.updatedAt[index],
    deletedAt: dto.deletedAt[index],
  }))
}

export default fromHardwareDtoToModel
